<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<profile-pds-p-text p-text id="{{ model.id }}" [innerHTML]="model.label"></profile-pds-p-text>
